<div class="d-flex wk-upload-image">
  <div class="section-width">
    <h3 class="section-header mb-0">
      {{ 'ADF_INSERT_MEDIA.SELECT_' + mediaType.toUpperCase() | translate }}
    </h3>
    <div class="d-flex">
      <div class="add-img-content">
        <div>
          <h3 class="sub-label mb-0">
            {{ 'ADF_INSERT_MEDIA.ADD_' + mediaType.toUpperCase() | translate }}
          </h3>
          <p class="img-text">
            {{
              'ADF_INSERT_MEDIA.FILE_FORMAT_' + mediaType.toUpperCase()
                | translate
            }}
          </p>
        </div>
        <button
          type="button"
          class="wk-button wk-button-ghost add-image"
          (click)="addMedia()"
          (keyup.enter)="addMedia()"
          [disabled]="disableAddbutton"
        >
          {{ 'ADF_INSERT_MEDIA.ADD_' + mediaType.toUpperCase() | translate }}
        </button>
      </div>
      <div class="search-bar">
        <wk-input class="wk-input">
          <input
            class="wk-field-input"
            placeholder="Search"
            autocomplete="off"
            type="text"
            #input
            [(ngModel)]="searchField"
            (mouseup)="blurFunc()"
            (focusout)="mouseDown()"
            (keyup.enter)="onSearch()"
            id="searchField"
            focus-me
          />
        </wk-input>
        <img
          class="padding-left c-pointer serch-icon"
          alt="Search"
          src="assets/images/search.svg"
          (click)="onSearch()"
          (keyup)="onSearch()"
        />
      </div>
    </div>

    <div class="wk-breadcrumb">
      <wk-breadcrumb
        *ngIf="!searchFiles"
        [folderNode]="breadCrumbNode"
        (navigate)="onBreadcrumbNavigate($event)"
      >
      </wk-breadcrumb>
    </div>
    <div class="folder-navigation" *ngIf="!searchFiles">
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-progress-spinner
          [color]="'primary'"
          [mode]="'indeterminate'"
          diameter="70"
        >
        </mat-progress-spinner>
      </div>

      <wk-media-tree-view-list
        *ngIf="(!isLoading && !notConfiguredFlag) || isNavigate"
        [node]="node"
        [mediaType]="mediaType"
        [currentSite]="currentSite"
      ></wk-media-tree-view-list>

      <div *ngIf="notConfiguredFlag" id="adf-tree-view-missing-node">
        {{
          'ADF_INSERT_MEDIA.NO_CONFIGURATION'
            | translate: { currentSite: currentSite }
        }}
      </div>
    </div>
    <div *ngIf="searchFiles">
      <div class="searchResultsHeading">
        {{ 'ADF_INSERT_MEDIA.SEARCH_RESULTS' | translate }}
      </div>
      <div *ngIf="spinner" class="loading-spinner">
        <mat-progress-spinner
          [color]="'primary'"
          [mode]="'indeterminate'"
          diameter="70"
        >
        </mat-progress-spinner>
      </div>
      <div *ngIf="!spinner">
        <div *ngFor="let file of resultFiles">
          <div
            class="parent-wrapper"
            [attr.aria-label]="file.entry.name"
            [attr.title]="file.entry.name"
            [ngStyle]="{ float: mediaType === 'audio' ? 'none' : 'left' }"
          >
            <div
              class="parent"
              [ngClass]="{ 'parent-then-audio': mediaType === 'audio' }"
              (click)="onMediaClicked($event, file)"
              (keyup)="onMediaClicked($event, file)"
            >
              <div
                class="child"
                [ngClass]="{ 'child-then-audio': mediaType === 'audio' }"
                [ngStyle]="{
                  padding:
                    mediaType === 'video' || mediaType === 'image' ? '10px' : 0
                }"
              >
                <button
                  id="{{ 'button-' + file.entry.name }}"
                  mat-icon-button
                  [attr.aria-label]="'toggle ' + file.entry.name"
                  #btn
                >
                  <ng-container
                    *ngIf="file?.entry?.content?.mimeType?.startsWith('image')"
                  >
                    <img
                      class="tree-image-node"
                      [src]="getMedia(file.entry.id)"
                      [alt]="file.entry.name"
                      decoding="async"
                      loading="lazy"
                    />
                  </ng-container>
                  <ng-container
                    *ngIf="file?.entry?.content?.mimeType?.startsWith('audio')"
                  >
                    <div
                      (click)="onMediaClicked($event, file)"
                      (keyup)="onMediaClicked($event, file)"
                    >
                      <span
                        *ngIf="!file?.isPlay"
                        (click)="onPlay($event, file)"
                        (keyup)="onPlay($event, file)"
                        class="wk-icon-filled-play"
                      ></span>
                      <span
                        *ngIf="file?.isPlay"
                        (click)="onPause($event, file)"
                        (keyup)="onPause($event, file)"
                        class="wk-icon-filled-pause"
                      ></span>
                      <div
                        (click)="onMediaClicked($event, file)"
                        (keyup)="onMediaClicked($event, file)"
                        class="adf-tree-view-title adf-tree-audio"
                      >
                        {{ file.entry.name }}
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="file?.entry?.content?.mimeType?.startsWith('video')"
                  >
                    <video
                      class="tree-image-node"
                      controls
                      preload="none"
                      [poster]="
                        getPoster(file.entry.properties['apollo:tenantId'])
                      "
                    >
                      <source
                        [src]="getMedia(file.entry.id)"
                        [type]="file.entry.content.mimeType"
                      />
                      {{
                        'APP.MESSAGES.ERRORS.BROWSER_NOT_SUPPORT_VIDEO'
                          | translate
                      }}
                      <source src="" type="video/webm" />
                      <track
                        label="English"
                        kind="captions"
                        srclang="en"
                        src=""
                        default
                      />
                    </video>
                  </ng-container>
                  <img
                    src="assets/images/document-view-details.png"
                    [title]="'APP.ACTIONS.DETAILS' | translate"
                    (click)="onPreviewClicked($event)"
                    (keyup)="onPreviewClicked($event)"
                    *ngIf="mediaType === 'image'"
                    class="wk-preview-icon"
                    [alt]="'APP.ACTIONS.DETAILS' | translate"
                  />
                </button>
                <div
                  class="adf-tree-view-title"
                  [ngStyle]="{
                    display: mediaType === 'audio' ? 'none' : 'block'
                  }"
                >
                  {{ file.entry.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="searchCompleted && totalItems > 0">
        <wk-pagination-bar
          id="pagination-custom-bar-dynamic"
          class="custom-paginator"
          [totalPages]="getTotalPages"
          [currentPage]="currentPage"
          [totalItems]="totalItems"
          [pageSizes]="itemsPerPage"
          [pageSize]="itemsOnPage"
          (pageClick)="onPageClick($event)"
          (pageSizeChange)="onSelect($event)"
        ></wk-pagination-bar>
      </div>
    </div>
  </div>
</div>
